import React from 'react';
import { faTrophy } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TrophyRegularIconProps {
  className?: string;
}

function TrophyRegularIcon(props: TrophyRegularIconProps) {
  return <FontAwesomeIcon icon={faTrophy} {...props} />;
}

export default TrophyRegularIcon;
